import { Button } from "@mui/material";
import { useCallback, useMemo, useRef } from "react";
import EntryDocumentsPanel from "components/ModuleDocuments/EntryDocumentsPanel";
import { normalizeRplDocuments } from "utils/rplDocumentUtils";

const DocumentsTab = ({ data, setData, isLoading, navigate }) => {
  // Stable, non-persisted ids for legacy plain-URL entries so React keys stay fixed
  // across re-renders without ever rewriting the original stored value.
  const legacyIdCache = useRef(new Map());
  const getStableId = useCallback((raw) => {
    if (!legacyIdCache.current.has(raw)) {
      legacyIdCache.current.set(raw, crypto.randomUUID());
    }
    return legacyIdCache.current.get(raw);
  }, []);

  const docs = useMemo(
    () => normalizeRplDocuments(data?.coe || [], getStableId),
    [data?.coe, getStableId]
  );

  return (
    <div className="space-y-4">
      {/* Older supporting documents saved without a name are kept as-is and shown as "Document". */}
      <EntryDocumentsPanel
        moduleType="RPL_CLIENT"
        entryId={data?.id}
        clientId={data?.clientId}
        documents={docs}
        onDocumentsChange={(coe) => setData((prev) => ({ ...prev, coe }))}
      />

      {/* Footer Actions */}
      <div className="px-6 py-4 border-t border-app-border flex justify-end gap-4">
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button variant="contained" type="submit" disabled={isLoading}>
          {isLoading ? "Saving..." : data?.id ? "Update" : "Submit"}
        </Button>
      </div>
    </div>
  );
};

export default DocumentsTab;
